import { render } from "./Pricing.vue?vue&type=template&id=546c60bb&bindings={}"
import script from "./Pricing.vue?vue&type=script&lang=js"
export * from "./Pricing.vue?vue&type=script&lang=js"
script.render = render

export default script